import { contentApi } from '@/infrastructure/Configuration'

export default class MemberBenefitsService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getAllMemberBenefits(params) {
    const { tier = '' } = params
    const url = `${contentApi}/rewards/all-benefits`

    try {
      const { data } = await this.httpClient.get(url)
      const { benefits, linkUrl } = data
      const benefitsList = tier ? this.filterMemberBenefitsByTierName(benefits, tier) : benefits || []
      benefitsList.push({ link: linkUrl || '#' })
      return benefitsList
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return []
    }
  }

  async getMemberServicesByTier(params) {
    const { tier = '' } = params
    const url = `${contentApi}/rewards/member-services/${tier}`

    try {
      const { data } = await this.httpClient.get(url)
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return []
    }
  }

  filterMemberBenefitsByTierName(benefits, tierName) {
    return benefits.filter(benefit => {
      const { categories } = benefit
      const category = categories.find(el => el.name.toLowerCase() === tierName.toLowerCase())
      return !!category?.isAvailable
    })
  }

  async getAllMemberBenefitsNlp() {
    const url = `${contentApi}/rewards/tier/benefits`
    const response = await this.httpClient.get(url)
    return response.data.tierBenefits
  }

  async getAllMemberBenefitsExtended() {
    const url = `${contentApi}/rewards/b2b/member/benefits`
    const response = await this.httpClient.get(url)
    return response.data.tiers
  }
}
